import { CustomsReasonToExport } from '@packlink/packlink-sdk';

const reasonsToExportOptions = [{
  value: CustomsReasonToExport.DOCUMENTS,
  label: 'customs-form.export-reason.documents'
}, {
  value: CustomsReasonToExport.PERSONAL_BELONGINGS,
  label: 'customs-form.export-reason.personal'
}, {
  value: CustomsReasonToExport.PURCHASE_OR_SALE,
  label: 'customs-form.export-reason.purchase'
}, {
  value: CustomsReasonToExport.RETURN,
  label: 'customs-form.export-reason.return'
}, {
  value: CustomsReasonToExport.SAMPLE,
  label: 'customs-form.export-reason.sample'
}];

export { reasonsToExportOptions };
//# sourceMappingURL=ReasonsToExport.js.map
